'use strict';

var $ = require('jquery');

var advert = require('../adverts/advert.js');
var analytics = require('../utils/analytics.js');
var config = require('../utils/config.js');
var heightWatcher = require('../watchers/height-watcher.js');
var layout = require('../ui/layout.js');
var tagManager = require('../utils/tagManager.js');
var youtube = require('../utils/youtube.js');
var timer = require('../utils/timer.js');

var royalSlider = require('royalslider');
require('jquery-panzoom');
require('jquery-mousewheel');

var classNames = {
	fullScreenGallery: 'full-screen-gallery',
	royalSliderOverflow: 'rsOverflow',
	slider: 'slider',
	topAd: 'top-ad'
};

var modifiers = {
	videoLoaded: 'video-loaded'
};

var slider, $gallery, $galleryControls, galleryLoaded = false;
var placementHtml, mobileAdFrequency, mobileAdDuration, remainingMobileAdDuration, desktopAdViewedDuration, desktopAdTimeout;
var isMobileLayout = false;
var listenForIndexChange = true;
var isNavigationEnabled = true;
var showCaption = true;
var mobileAdDurationTimer;
var inactivityTimer;
var pageLocation;

var viewCount = 0;
var gaPageOverride = config.dataLayer.page.galleryGaLocation;

function getSlider() {
	return $.findByBem(classNames.fullScreenGallery, 'slider').data('royalSlider');
}

function toggleMobileTopAd() {
	// top (bottom) ad interferes with navigation controls in some mobile browsers
	if (layout.isMobile()) {
		$.findByBem(classNames.topAd).toggle();
	}
}

function mobileAdsEnabled() {
	return placementHtml && mobileAdFrequency > 0;
}

function isImageSlide(id) {
	var image = slider.slides[id].content.filter('.rsImg');
	return image.length > 0;
}

function isVideoSlide(id) {
	var video = slider.slides[id].content.filter('[data-gallery-video]');
	return video.length > 0;
}

function getGalleryTemplateName() {
	var galleryTemplate = 'CarGallery';
	if (window.location.pathname.startsWith('/vans-pickups/')) {
		galleryTemplate = 'VanGallery';
	}
	return galleryTemplate;
}

function logView(segment) {
	var pageTemplateName = config.dataLayer.page.templateName;
	var galleryTemplate = getGalleryTemplateName();

	// NOTE: this format of 'push' into the datalayer results in the
	// datalayer variable defined by the dot-notation-path being created/updated
	tagManager.pushToDataLayer({
		'page.templateName': galleryTemplate
	});

	analytics.trackPageview(gaPageOverride + segment + '/');

	// Revert to the underlying page's template name in case
	// the value is required before a subsequent logView
	tagManager.pushToDataLayer({
		'page.templateName': pageTemplateName
	});

	analytics.trackIpsosIrisPageView();
}

function logImageView(imageIndex) {
	var action = pageLocation ? 'Image viewed - ' + pageLocation : 'Image viewed';
	analytics.trackEvent('Full Screen Gallery', action, config.dataLayer.vehicle.modelName);

	var imageNumber = imageIndex + 1;
	logView(imageNumber);
}

function logVideoSlideView(slideIndex) {
	analytics.trackEvent('Full Screen Gallery', 'Video slide viewed', config.dataLayer.vehicle.modelName);

	var videoNumber = slideIndex + 1;
	logView('video/' + videoNumber);
}

function logSlideView(slideIndex) {
	analytics.trackEvent('Full Screen Gallery', 'Slide viewed', config.dataLayer.vehicle.modelName);

	var $slideContent = slider.slides[slideIndex].content.filter('.rsContent');
	var slideName = $slideContent.data('ga-slide-name') || 'content-slide';

	logView(slideName);
}

function logViewByContentType(slideIndex) {
	if (isImageSlide(slideIndex)) {
		logImageView(slideIndex);
	}
	else if (isVideoSlide(slideIndex)) {
		logVideoSlideView(slideIndex);
	}
	else {
		logSlideView(slideIndex);
	}
}

function logVideoPlay() {
	analytics.trackEvent('Full Screen Gallery', 'Video played', config.dataLayer.vehicle.modelName);
}

function removeAdSlides(retainIndexId) {
	var adSlides = $.grep(slider.slides, function (slide) {
		var adContainer = slide.content.filter('.mpu-container');
		return adContainer.length > 0;
	});

	$.each(adSlides, function (index) {
		if (!retainIndexId || adSlides[index].id !== retainIndexId) {
			slider.removeSlide(adSlides[index].id);

			// we've just removed a slide so the the retain index id needs to be
			// updated to keep in line
			if (retainIndexId) {
				retainIndexId--;
			}
		}
	});
}

function appendAdSlide() {
	$('.mpu-container', $gallery).each(function () {
		$(this).remove();
	});

	removeAdSlides();

	// append slide so an ad appears if navigated to previous
	slider.appendSlide(placementHtml, slider.currSlideId === 0 ? slider.numSlides + 1 : slider.currSlideId);

	// append slide so an ad appears if navigated to next
	slider.appendSlide(placementHtml, slider.currSlideId + 1);
}

function slideContainsAd(id) {
	var adContainer = slider.slides[id].content.filter('.mpu-container');
	return adContainer.length > 0;
}

function currentSlideContainsAd() {
	return slideContainsAd(slider.currSlideId);
}

function nextSlideContainsAd(direction) {
	var previousSlideId = slider.currSlideId === 0 ? slider.numSlides - 1 : slider.currSlideId - 1;
	var nextSlideId = slider.currSlideId + 1 === slider.numSlides ? 0 : slider.currSlideId + 1;

	if ((direction === "prev" && slideContainsAd(previousSlideId)) ||
		(direction === "next" && slideContainsAd(nextSlideId))) {
		return true;
	}

	return false;
}

function setTransitionSpeed(speed) {
	var transitionSpeed = layout.isMobile() ? 300 : 600;
	slider.st.transitionSpeed = speed ? speed : transitionSpeed;
}

function updateCaption() {
	var $caption = $.findByBem(classNames.fullScreenGallery, 'caption');
	var caption = $('.rsGCaption').text().trim();

	$.findByBem(classNames.fullScreenGallery, 'caption__text').text(caption);

	if (showCaption) {
		if (!caption || currentSlideContainsAd()) {
			$caption.slideUp();
		}
		else if (caption && !currentSlideContainsAd() && !$caption.is(':visible')) {
			$caption.slideDown();
		}
	}
}

function disableNavigation() {
	slider.st.sliderDrag = false;
	slider.st.sliderTouch = false;
	isNavigationEnabled = false;

	$('.full-screen-gallery__slider').addClass('rsNoDrag');
	$('.full-screen-gallery__controls').slideUp();
}

function enableNavigation() {
	slider.st.sliderDrag = true;
	slider.st.sliderTouch = true;
	isNavigationEnabled = true;

	$('.full-screen-gallery__slider').removeClass('rsNoDrag');
	$('.full-screen-gallery__controls').slideDown();
}

function getActiveSlideImage() {
	return $('.rsActiveSlide > .rsImg', $gallery);
}

function getActivePanzoomContainer() {
	return $('.rsActiveSlide > .panzoomContainer', $gallery);
}

function initPanzoom() {
	var $panzoomContainer = getActivePanzoomContainer();
	var $activeImage = getActiveSlideImage();

	if ($panzoomContainer.length || !$activeImage.length) {
		// panzoom is already init'd or active slide image not found
		return;
	}

	$activeImage.wrap("<div class='panzoomContainer'></div>");

	$panzoomContainer = getActivePanzoomContainer();

	$panzoomContainer.panzoom({
		cursor: 'grab',
		contain: 'automatic',
		increment: 0.3,
		minScale: 1,
		maxScale: 2,
		panOnlyWhenZoomed: true
	});

	$panzoomContainer.on('mousewheel', function (event) {
		event.preventDefault();
		var delta = event.delta || event.originalEvent.wheelDelta;
		var zoomOut = delta ? delta < 0 : event.originalEvent.deltaY > 0;
		$(this).panzoom('zoom', zoomOut);
	});
}

function getYouTubeIFrames() {
	return $.findByBem('full-screen-gallery__slider__youtube-player', 'iframe', null, $gallery);
}

function getYouTubePlayerIFrame() {
	return $.findByBem('full-screen-gallery', 'slider__youtube-player__iframe', null, $gallery);
}

function stopYouTubeVideos() {
	var $iframes = getYouTubeIFrames();
	$iframes.each(function () {
		youtube.stopVideo($(this).attr('id'));
	});
}

function initYouTubeVideos() {
	youtube.init($gallery);

	// subscribe to the first youtube video play event and log it
	var $iframes = getYouTubeIFrames();
	$iframes.each(function () {
		$(this).on('youtube-video-playing', function () {
			logVideoPlay();
			$(this).off('youtube-video-playing');
		});

		if (layout.isMobile()) {
			$(this).attr('allowfullscreen', '');
		}
	});
}

function resetInactivityTimer() {
	if (inactivityTimer) {
		timer.cancel(inactivityTimer);
	}

	inactivityTimer = timer.begin(function () {
		advert.disableGalleryAdsAutoRefresh();
	}, 30000);
}

function updateAdSlideTimer() {
	var durationMessage = '';
	var $durationElement = $.findByBem(classNames.fullScreenGallery, 'adverts__remaining-ad-duration');

	if (remainingMobileAdDuration > 0) {
		durationMessage = ' - You can skip in ' + remainingMobileAdDuration + 's';
	}
	else {
		window.clearInterval(mobileAdDurationTimer);
	}

	$durationElement.text(durationMessage);
	remainingMobileAdDuration -= 1;
}

function mobileSlideChange() {
	if (!mobileAdsEnabled()) {
		return;
	}

	// stop listening for index change events, they fire when dynamically adding & removing slides
	listenForIndexChange = false;

	if (currentSlideContainsAd()) {
		viewCount = 0;
		remainingMobileAdDuration = mobileAdDuration / 1000;

		var $context = $.findByBem(classNames.fullScreenGallery, 'slider');
		var googleQueryId = $('.rsActiveSlide .mpu-ad', $context).data('google-query-id');

		if (!googleQueryId) {
			removeAdSlides(slider.currSlideId);
			advert.loadMobileGalleryAds($('.rsActiveSlide', $context));
		}

		updateAdSlideTimer();
		mobileAdDurationTimer = setInterval(function () {
			updateAdSlideTimer();
		}, 1000);

		setTimeout(function () {
			enableNavigation();
		}, mobileAdDuration);
	}
	else if (viewCount >= mobileAdFrequency) {
		appendAdSlide();
	}
	else {
		removeAdSlides();
	}

	listenForIndexChange = true;
}

function onIndexChange() {
	stopYouTubeVideos();
	updateCaption();

	viewCount++;

	if (layout.isMobile()) {
		mobileSlideChange();
	}

	if (!layout.isMobile() || (layout.isMobile() && !currentSlideContainsAd())) {
		if (isImageSlide(slider.currSlideId)) {
			initPanzoom();
		}

		logViewByContentType(slider.currSlideId);
	}

	resetInactivityTimer();
}

function onBeforeIndexChange(direction) {
	getActivePanzoomContainer().panzoom("reset");

	var relativeDirection = direction;
	if (relativeDirection !== 'next' && relativeDirection !== 'prev') {
		// Drag gives target slide rather than direction so work out which way its going
		var currentSlideIndex = slider.currSlideId;

		if (currentSlideIndex < direction) {
			relativeDirection = 'next';
		} else {
			relativeDirection = 'prev';
		}
	}

	if (layout.isMobile() && mobileAdsEnabled() && nextSlideContainsAd(relativeDirection)) {
		disableNavigation();
	}
}

function onContentSet() {
	initPanzoom();
}

function setYouTubeVideosFullscreenAttribute(allowFullScreen) {
	var $iframes = getYouTubeIFrames();
	$iframes.each(function () {
		if (allowFullScreen) {
			$(this).attr('allowfullscreen', '');
		}
		else {
			$(this).removeAttr('allowfullscreen');
		}
	});
}

function shouldResizeVideoPlayer() {
	var $sliderContainer = $.findByBem(classNames.fullScreenGallery, classNames.slider);
	return $sliderContainer.hasBemClass(classNames.fullScreenGallery, classNames.slider, modifiers.videoLoaded) && $sliderContainer.is(':visible');
}

function adjustVideoSizeBasedOnUserResolution() {
	var $sliderOverflow = $.findByBem(classNames.fullScreenGallery, classNames.slider).find('.' + classNames.royalSliderOverflow);
	var videoContainerHeight = parseInt($sliderOverflow.css('height'), 10);
	var videoContainerWidth = parseInt($sliderOverflow.css('width'), 10);

	if (!shouldResizeVideoPlayer()) {
		return;
	}

	var percentage = 0.75;
	var heightRatio = 9 / 16;
	var widthRatio = 16 / 9;
	var height = 0;
	var width = 0;

	//reduce the size of the Youtube video container by 25%. 
	//This will provide us with the available dimensions in order to fit the video.
	//The higher is the percentage the smaller the video will be.
	//25% is a good balance between reduction and video size.
	var availableHeight = videoContainerHeight * percentage;
	var availableWidth = videoContainerWidth * percentage;

	//the top margin needs to be calculate.The difference between the Youtube video container will give the absolute distance between 
	// the X and Y. By dividing to 100 we  will take the 100th part of that. It is similar to a percentage.
	//Eg 1600 - 500 = 1100; margin = 1100 / 100 = 11
	var marginTop = Math.abs(videoContainerWidth - videoContainerHeight) / 100;

	//Calculate the required height from the container width and multiply it by the heightRatio
	var requiredHeight = videoContainerWidth * heightRatio;

	if (requiredHeight > availableHeight) {
		//if so calculate the width as a proportion of the availble height and the width ratio
		//the height remain unchanged.
		width = availableHeight * widthRatio;
		height = availableHeight;
	} else {
		//otherwise calculate the height as a proportion of the availble width and the width ratio heightRatio
		//the width remain unchanged.
		width = availableWidth;
		height = availableWidth * heightRatio;
	}

	var ytiFrame = getYouTubePlayerIFrame();
	ytiFrame.css({
		height: height + 'px',
		'margin-top': marginTop + 'rem',
		width: width + 'px'
	});
}

function onWindowResize() {
	var $thumbnails = $('.rsNav');

	if (isMobileLayout && !layout.isMobile()) {
		// handle window resize from small -> large
		removeAdSlides();
		$.findByBem(classNames.fullScreenGallery, 'adverts__inner__mpu').html(placementHtml);
		$thumbnails.show();
		setYouTubeVideosFullscreenAttribute(false);
	} else if (!isMobileLayout && layout.isMobile()) {
		// handle window resize from large -> small
		$thumbnails.hide();
		setYouTubeVideosFullscreenAttribute(true);
		advert.disableGalleryAdsAutoRefresh();
	}

	setTransitionSpeed();

	if (!layout.isMobile()) {
		adjustVideoSizeBasedOnUserResolution();
	} else {
		var ytiFrame = getYouTubePlayerIFrame();
		ytiFrame.css({
			height: '',
			margin: '',
			width: ''
		});
	}

	isMobileLayout = layout.isMobile();
}

function closeGallery() {

	advert.resetTargeting();
	advert.disableGalleryAdsAutoRefresh();

	if (inactivityTimer) {
		timer.cancel(inactivityTimer);
	}

	if (layout.isMobile()) {
		listenForIndexChange = false;
		removeAdSlides();
		listenForIndexChange = true;
		toggleMobileTopAd();
	}

	$("body").off("touchmove");

	$.findByBem(classNames.fullScreenGallery, 'container').fadeOut('slow');
	$.findByBem(classNames.fullScreenGallery, 'adverts__inner__mpu').html(placementHtml);

	stopYouTubeVideos();
}

function handleGalleryEscape(event) {
	if (!$gallery.is(':visible')) {
		return;
	}

	var isEscape = false;

	if ("key" in event && event.key) {
		isEscape = event.key === "Escape" || event.key === "Esc";
	} else {
		isEscape = event.keyCode === 27;
	}

	if (isEscape) {
		closeGallery();
	}
}

function initGalleryControls() {
	$galleryControls = $.findByBem(classNames.fullScreenGallery, 'controls');

	$('[data-elem="prev"]', $galleryControls).on('click.full-screen-gallery-prev', function () {
		if (isNavigationEnabled) {
			slider.prev();
		}
	});

	$('[data-elem="next"]', $galleryControls).on('click.full-screen-gallery-next', function () {
		if (isNavigationEnabled) {
			slider.next();
		}
	});

	$('[data-elem="zoomIn"]', $galleryControls).on('click.full-screen-gallery-zoomIn', function () {
		getActivePanzoomContainer().panzoom('zoom');
	});

	$('[data-elem="zoomOut"]', $galleryControls).on('click.full-screen-gallery-zoomOut', function () {
		getActivePanzoomContainer().panzoom('zoom', true);
	});

	$('[data-elem="close"]', $gallery).on('click.full-screen-gallery-close', function () {
		closeGallery();
	});

	$('[data-elem="captionToggle"]', $galleryControls).on('click.full-screen-gallery-captionToggle', function () {
		var $caption = $.findByBem(classNames.fullScreenGallery, 'caption');
		$caption.slideToggle('slow', function () {
			showCaption = $(this).is(':visible');
		});
	});

	$('[data-elem="thumbsToggle"]', $galleryControls).on('click.full-screen-gallery-thumbsToggle', function () {
		$('.rsNav').slideToggle('slow');
	});
}

function initAdProperties() {
	var $adverts = $.findByBem(classNames.fullScreenGallery, 'adverts__inner');
	placementHtml = $adverts.findByBem(classNames.fullScreenGallery, 'adverts__inner__mpu').html();
	mobileAdFrequency = $adverts.data('mobile-ad-frequency');
	mobileAdDuration = $adverts.data('mobile-ad-duration');
	desktopAdViewedDuration = $adverts.data('desktop-ad-viewed-duration');
	desktopAdTimeout = $adverts.data('desktop-ad-timeout');
}

function initEvents() {
	slider.ev.on('rsBeforeMove', function (event, type) {
		onBeforeIndexChange(type);
	});

	slider.ev.on('rsAfterSlideChange', function () {
		if (listenForIndexChange) {
			onIndexChange();
		}
	});

	slider.ev.on('rsAfterContentSet', function () {
		if (listenForIndexChange) {
			onContentSet();
		}
	});

	$(window).on('resize', function () {
		setTimeout(function () {
			onWindowResize();
		}, 250);
	});

	$(document).on('keydown.full-screen-gallery-escape', function (event) {
		handleGalleryEscape(event);
	});

	getYouTubePlayerIFrame().on('load', function () {
		var $sliderContainer = $.findByBem(classNames.fullScreenGallery, classNames.slider);
		$sliderContainer.addBemClass(classNames.fullScreenGallery, classNames.slider, modifiers.videoLoaded);

		if (!layout.isMobile()) {
			adjustVideoSizeBasedOnUserResolution();
		}
	});
}

function numImagesToPreload() {
	if (layout.isMobile()) {
		return 2;
	}

	return 4;
}

function watchInsuranceQuoteContainerSpace() {
	//watch mpu and hide insurance quote link if it is a dmpu
	heightWatcher.watchElementHeight($.findByBem(classNames.fullScreenGallery, 'adverts__inner__mpu'), 2000, function () {
		if ($.findByBem(classNames.fullScreenGallery, 'adverts__inner__mpu').height() > 250) {
			$.findByBem(classNames.fullScreenGallery, 'insurance-quote-container').removeBemClass(classNames.fullScreenGallery, 'insurance-quote-container', 'show');
			$.findByBem(classNames.fullScreenGallery, 'insurance-quote-container').addBemClass(classNames.fullScreenGallery, 'insurance-quote-container', 'hide');
		}
		else {
			$.findByBem(classNames.fullScreenGallery, 'insurance-quote-container').removeBemClass(classNames.fullScreenGallery, 'insurance-quote-container', 'hide');
			$.findByBem(classNames.fullScreenGallery, 'insurance-quote-container').addBemClass(classNames.fullScreenGallery, 'insurance-quote-container', 'show');
		}
	});
}

function chooseImagesForScreensize() {
	var screenSize = layout.getScreenSize();
	$('a.rsImg').each(function () {
		var link = $(this);
		var href = link.attr('data-href-' + screenSize);
		if (href) {
			link.attr('href', href);
		}
	});
}

function loadRoyalSlider(callback) {
	chooseImagesForScreensize();

	$('.royalSlider').royalSlider({
		controlNavigation: 'thumbnails',
		addActiveClass: true,
		autoScaleSlider: true,
		loop: true,
		imageScaleMode: 'fit',
		imageAlignCenter: true,
		navigateByClick: false,
		numImagesToPreload: numImagesToPreload(),
		arrowsNav: false,
		keyboardNavEnabled: true,
		fadeinLoadedSlide: true,
		globalCaption: true,
		globalCaptionInside: true,
		controlsInside: false
	});

	slider = getSlider();
	initGalleryControls();
	initAdProperties();
	initYouTubeVideos();
	initEvents();

	updateCaption();

	isMobileLayout = layout.isMobile();

	galleryLoaded = true;

	callback();
}

function openGalleryAtIndex(index, initialOpen, requestOrigin) {

	var galleryTemplate = getGalleryTemplateName();
	advert.overridePageType(galleryTemplate);

	if (typeof royalSlider !== 'undefined') {
		var action = pageLocation ? 'Opened - ' + pageLocation : 'Opened';
		analytics.trackEvent('Full Screen Gallery', action, requestOrigin);

		slider = getSlider();

		if (slider) {
			// If the requested index is the same as the current one then manually log the view and reset the inactivity timer. 
			// If the gallery is already init'd it will fire an onChange event if the index is different.
			if (slider.currSlideId === index) {
				logViewByContentType(slider.currSlideId);
				resetInactivityTimer();
			}

			// If this is the first time open and the first slide selected then
			// the index change event won't fire, manually increase the viewcount.
			if (initialOpen && index === 0) {
				viewCount = 1;
			}

			toggleMobileTopAd();
			setTransitionSpeed(0);
			slider.goTo(index);
			setTransitionSpeed();

			$.findByBem(classNames.fullScreenGallery, 'container').fadeIn(300, function () {
				setTimeout(function () {
					slider.updateSliderSize(true);
					slider.updateSliderSize(true); //this must be triggered twice as jQuery 3 changed the height/width calc, causing images to be too small
				}, 10);

				$('body').on('touchmove', function (event) {
					event.preventDefault();
				});
			});

			if (layout.isMobile()) {
				advert.loadMobileGalleryAds($gallery, true);
			} else {
				advert.loadDesktopGalleryAds($gallery, desktopAdViewedDuration, desktopAdTimeout);
			}

			watchInsuranceQuoteContainerSpace();

			var $sliderOverflow = $.findByBem(classNames.fullScreenGallery, classNames.slider).find('.' + classNames.royalSliderOverflow);
			heightWatcher.watchElementHeight($sliderOverflow, 500, function () {
				adjustVideoSizeBasedOnUserResolution();
			});
		}
	}
}

function showIndex(index, requestOrigin) {
	index = parseInt(index);

	if (!isNaN(index)) {
		if (!galleryLoaded) {
			loadRoyalSlider(function () {
				window.setTimeout(function () {
					openGalleryAtIndex(index, true, requestOrigin);
				}, 100);
			});
		} else {
			openGalleryAtIndex(index, false, requestOrigin);
		}
	}
}

function initGalleryLinks(context) {
	$('a[data-gallery-index]', context).off('click.full-screen-gallery').on('click.full-screen-gallery', function (e) {
		e.preventDefault();

		var index = $(this).data('gallery-index');
		var origin = $(this).data('gallery-launch-origin');
		pageLocation = $(this).data('gallery-page-location');

		showIndex(index, origin);
	});
}

module.exports = {
	init: function (context) {
		$gallery = $.findByBem(classNames.fullScreenGallery);

		if ($gallery.length > 0) {
			initGalleryLinks(context);
		}
	},

	open: function (index) {
		if ($gallery.length > 0) {
			showIndex(index);
		}
	}
};